import { observer } from "mobx-react";
import React from "react";
import {AirlineLogoLargeMulticolorIcon} from "../../../../assets/svg/airline-logo-large-multicolor.icon";
import styled from "styled-components";
import {CloseSideMenuButtonComponent} from "../../../../components/burger-menu/close-side-menu-button.component";
import {useServices} from "../../../../hooks/use-services.hook";

const SideMenuHeaderBox = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    box-shadow: ${props => props.theme.boxShadow.dropShadow};
    padding: calc(env(safe-area-inset-top) + ${props => props.theme.spacing.spacing30}) 
            ${props => props.theme.spacing.spacing16} 
            ${props => props.theme.spacing.spacing16} 
            ${props => props.theme.spacing.spacing16};
`

const CloseButtonWrapperBox = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-bottom: calc(-1 * ${props => props.theme.spacing.spacing12});
`


export const HybridPageSideMenuHeaderComponent: React.FC = observer(() => {
    const services = useServices();
    return (
        <SideMenuHeaderBox>
            <AirlineLogoLargeMulticolorIcon size={3}/>
            <CloseButtonWrapperBox>
                <CloseSideMenuButtonComponent sideMenuController={services.sideMenu.hybridMainSideMenuController} />
            </CloseButtonWrapperBox>

        </SideMenuHeaderBox>
    )
})